export default {
  // 选择已生效项目
  LIST_CONTRACT: '/sales/wm/project/listProjectByPage',
  // 保存接口
  SAVE_CONTRACT: '/sales/contractInfo/saveContract',
  // 获取已生效的项目详情
  GET_PROJECT_DETAIL: '/sales/wm/project/getProject',
  // 合同分页查询
  LIST_CONTRACT_BY_PAGE: '/sales/contractInfo/listContractByPage',
  // 合同详情(根据id值)
  GET_CONTRACT_DETAIL: '/sales/contractInfo/getContract',
  // 合同导出
  EXPORT_CONTRACT: '/sales/contractInfo/exportContract',
  // 合同删除
  DELETE_CONTRACT: '/sales/contractInfo/delete',
  // 合同关闭
  CLOSE_CONTRACT: '/sales/contractInfo/close',
  // 合同审批
  APPROVAL_CONTRACT: '/sales/contractInfo/approval',
  // 查找历史版本
  QUERY_HISTORY_VISION: '/sales/contractInfo/detailPast',
  // 查看发票
  QUERY_INVOICE: '/financial/financeSalesInvoice/invoiceInfo',
  // 收款接口
  QUERY_RECEIVED: '/financial/fundCollectionClaim/contractByList',
  // 查询结算列表
  QUERY_SETTLEMENT_LIST: '/financial/receivableSettlement/list',
  // 查询库存记录
  QUERYINVENTORY: '/sales/IOGoodsDetail/page',
};
